import React from 'react'

const TotalAdCost = () => {
    return (
        <div className='bg-[#CCCCCC] w-full p-3'>TotalAdCost: £ <span className='font-semibold text-lg'> 7.99 </span></div>
    )
}

export default TotalAdCost